import React from "react";
import Cookies from "universal-cookie";
import moment from "moment";
import { Buffer } from "buffer";

import { withRouter } from "../../hoc/withRouter";
import withAuth from "../../hoc/withAuth";

import MainLayout from "../../components/layouts/MainLayout";

import { Form, DatePicker, Table, Button, Modal, Row, Col, Tooltip } from "antd";
import { SearchOutlined, CopyOutlined } from "@ant-design/icons";

import ServicebureauSelect from "../../components/servicebureau/ServicebureauSelect";

// import SelectStatusBayar from "../components/selects/SelectStatusBayar";
// import SelectStatusNotice from "../components/selects/SelectStatusNotice";
// import SelectDealer from "../components/selects/SelectDealer";
// import SelectStatusBBN from "../components/selects/SelectStatusBBN";
import { orderService } from "../../services/otodisApi/OrderService";
import ModalPaymentApproval from "../../components/misc/ModalPaymentApproval";

interface PaymentApprovalProps {
  match: any;
}

interface PaymentApprovalState {
  service_code: string;
  processing: boolean;
  processingFetchTableData: boolean;
  dataOrder: any[];
  pageSize: number;
  filterValueDealer: string;
  filterValueDate: string;
  filterValueStatus: string;
  filterValueStatusNotice: string;
  filterValueNosin: string;
  loadingButton: boolean;
  tableSelectedRowKeys: any[];
  rowPaymentApproval: any;
  showModalPaymentApproval: boolean;
}

class PaymentApproval extends React.Component<PaymentApprovalProps, PaymentApprovalState> {
  private token = new Cookies().get("_t");
  private user = JSON.parse(Buffer.from(new Cookies().get("_u"), "base64").toString());

  tableColumn: any[] = [
    {
      title: "Aksi",
      dataIndex: "aksi",
      width: 120,
      render: (value: string, row: any) => {
        return (
          <Button type="primary" onClick={() => this.handleApproval(row)}>
            Approval
          </Button>
        );
      },
    },
    {
      title: "Kode Order",
      dataIndex: "order_code",
      width: 180,
      render: (value: string) => {
        return (
          <span style={{ fontSize: "80%" }}>
            {`${value}`}
            &nbsp; &nbsp;
            <Tooltip title="Click untuk copy kode order" color={"cyan"}>
              <CopyOutlined className={"small-avatar-link"} onClick={(event) => this.copyToClipboard(value)} />
            </Tooltip>
          </span>
        );
      },
    },
    {
      title: "Biro Jasa",
      dataIndex: "service_bureau_name",
      width: 150,
      render: (value: string, row: any) => {
        return (
          <span style={{ fontSize: "80% " }}>
            {`${value}`}
            <br />
            {row.service_bureau_code}
          </span>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "transfer_title_status",
      width: 80,
      render: (value: string) => {
        return <span style={{ fontSize: "80%" }}>{`${value}`}</span>;
      },
    },
    {
      title: "Tgl Closing",
      dataIndex: "order_closing_date",
      width: 100,
      render: (value: string) => {
        return <span style={{ fontSize: "80%" }}>{`${value}`}</span>;
      },
    },
    {
      title: "Tgl BAST",
      dataIndex: "handover_delivery_date",
      width: 100,
      render: (value: string) => {
        return <span style={{ fontSize: "80%" }}>{`${value}`}</span>;
      },
    },
    {
      title: "Tgl Penugasan",
      dataIndex: "create_date",
      width: 100,
      render: (value: string) => {
        return <span style={{ fontSize: "80%" }}>{`${value}`}</span>;
      },
    },
    {
      title: "Nama Konsumen",
      dataIndex: "customer_doc_name",
      width: 120,
      render: (value: string) => {
        return <span style={{ fontSize: "80%" }}>{`${value}`}</span>;
      },
    },
    {
      title: "Nomor Mesin",
      dataIndex: "vehicle_engine_number",
      width: 100,
      render: (value: string) => {
        return <span style={{ fontSize: "80%" }}>{`${value}`}</span>;
      },
    },
    {
      title: "Lunas PK",
      dataIndex: "flag_has_outstanding",
      key: "flag_has_outstanding",
      width: 70,
      render: (value: string) => {
        return <span style={{ fontSize: "80%" }}>{`${value}`}</span>;
      },
    },
    {
      title: "Payment Approved",
      dataIndex: "payment_approved",
      key: "payment_approved",
      width: 90,
      render: (value: string) => {
        return <span style={{ fontSize: "80%" }}>{`${value}`}</span>;
      },
    },
    {
      title: "Nilai Notice",
      dataIndex: "notice_cost",
      width: 100,
      render: (value: string, row: any) => {
        return <span style={{ fontSize: "80% " }}>{`${value?.toLocaleString()}`}</span>;
      },
    },
    {
      title: "Nilai Proses",
      dataIndex: "process_cost",
      width: 100,
      render: (value: string, row: any) => {
        return <span style={{ fontSize: "80% " }}>{`${value?.toLocaleString()}`}</span>;
      },
    },
    {
      title: "Nilai BBN",
      dataIndex: "transfer_title_cost",
      width: 100,
      render: (value: string, row: any) => {
        return <span style={{ fontSize: "80% " }}>{`${value?.toLocaleString()}`}</span>;
      },
    },
    {
      title: "Lunas Notice",
      dataIndex: "paid_notice_cost",
      key: "paid_notice_cost",
      width: 100,
      render: (value: string, row: any) => {
        return (
          <React.Fragment>
            <span style={{ fontSize: "80% " }}>
              <b>{row.paid_notice_cost ? "SUDAH BAYAR" : "BELUM BAYAR"}</b>
            </span>
          </React.Fragment>
        );
      },
    },
    {
      title: "Tgl Bayar Notice",
      dataIndex: "paid_notice_cost_date",
      key: "paid_notice_cost_date",
      width: 80,
      render: (value: string, row: any) => {
        return (
          <React.Fragment>
            <span style={{ fontSize: "80% " }}> {`${row.paid_notice_cost_date}`}</span>
          </React.Fragment>
        );
      },
    },
    {
      title: "Lunas Proses",
      dataIndex: "paid_process_cost",
      key: "paid_process_cost",
      width: 100,
      render: (value: string, row: any) => {
        return (
          <React.Fragment>
            <span style={{ fontSize: "80% " }}>
              <b>{row.paid_process_cost ? "SUDAH BAYAR" : "BELUM BAYAR"}</b>
            </span>
          </React.Fragment>
        );
      },
    },
    {
      title: "Tgl Bayar Proses",
      dataIndex: "paid_process_cost_date",
      key: "paid_process_cost_date",
      width: 80,
      render: (value: string, row: any) => {
        return (
          <React.Fragment>
            <span style={{ fontSize: "80% " }}> {`${row.paid_process_cost_date}`}</span>
          </React.Fragment>
        );
      },
    },
  ];

  constructor(props: PaymentApprovalProps) {
    super(props);

    const { match } = this.props;

    this.state = {
      service_code: "",
      processing: false,
      processingFetchTableData: false,
      dataOrder: [],
      pageSize: 100,
      filterValueDealer: match.params.dealerCode.replace(/-/g, "#"),
      filterValueDate: "",
      filterValueStatus: "INPUTED",
      filterValueStatusNotice: "ALL",
      filterValueNosin: "",
      loadingButton: false,
      tableSelectedRowKeys: [],
      showModalPaymentApproval: false,
      rowPaymentApproval: [],
    };
  }

  copyToClipboard = async (data: any) => {
    await navigator.clipboard.writeText(data);
  };

  handleApproval = (row: any) => {
    this.setState({
      rowPaymentApproval: row,
      showModalPaymentApproval: true,
    });
  };

  closeModalPaymentApproval = () => {
    this.setState({
      showModalPaymentApproval: false,
    });
  };

  onApprovePayment = async () => {
    try {
      // console.log("rowPaymentApproval", this.state.rowPaymentApproval);
      // console.log("data", this.state.dataOrder);

      // return;
      const { rowPaymentApproval, dataOrder } = this.state;

      if (rowPaymentApproval.order_code && rowPaymentApproval.service_bureau_code) {
        this.setState({
          loadingButton: true,
        });

        const postData = {
          service_bureau_code: rowPaymentApproval.service_bureau_code,
          order_code: rowPaymentApproval.order_code,
          payment_approved: true,
          updated_by: this.user,
        };

        await orderService.bbnApprovalPayment(postData).then((resp) => {
          Modal.success({
            title: "Proses Sukses",
            content: resp.data.message,
          });

          const updatedDataOrder = dataOrder.filter((order: any) => order.order_code !== rowPaymentApproval.order_code);

          this.setState({
            showModalPaymentApproval: false,
            loadingButton: false,
            rowPaymentApproval: [],
            dataOrder: updatedDataOrder,
          });
        });
      } else {
        Modal.error({
          title: "Validation Error",
          content: "Kode Order Kosong",
        });
      }
    } catch (error: any) {
      Modal.error({
        title: "Proses Gagal",
        content: "Server Menolak Inputan Anda :" + error.message,
      });
      this.setState({
        loadingButton: false,
      });
    }
  };

  onDealerChange = async (data: any) => {
    this.setState({
      loadingButton: true,
      filterValueDealer: data.value,
    });
  };

  changeFilterDealer = (v: string) => {
    this.setState({
      filterValueDealer: v,
    });
  };

  changeFilterDate = (date: any, dateString: string) => {
    this.setState({
      filterValueDate: dateString,
    });
  };

  changeFilterStatus = (v: string) => {
    this.setState({
      filterValueStatus: v,
    });
  };

  changeFilterStatusNotice = (v: string) => {
    this.setState({
      filterValueStatusNotice: v,
    });
  };

  changeFilterNosin = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      filterValueNosin: e.target.value,
    });
  };

  changeServiceBureau = (data: any) => {
    this.setState({
      service_code: data.value,
      //   supplierName: data.children,
    });
  };

  clickSearch = async () => {
    try {
      const filter = this.state;

      if (!filter.filterValueDealer) {
        throw new Error("Dealer is Required");
      }
      if (!filter.service_code) {
        throw new Error("Biro Jasa is Required");
      }
      if (!filter.filterValueDate) {
        throw new Error("Date is Required");
      }

      const params = {
        service_bureau_code: filter.service_code,
        dealer_code: filter.filterValueDealer,
        date_start: moment(filter.filterValueDate).clone().startOf("month").format("YYYY-MM-DD"),
        date_end: moment(filter.filterValueDate).clone().endOf("month").format("YYYY-MM-DD"),
        transfer_title_status: "UPLOADED",
        notice_uploaded: true,
        payment_approved: false,
        // vehicle_engine_number: "JM91E 3688408",
      };

      this.setState({
        processingFetchTableData: true,
        loadingButton: true,
      });
      //   console.log("params", params);
      //   console.log("token", this.token);
      orderService.setToken(this.token);
      const dataOrder = await orderService.getAssignedOrder(params);

      this.setState({
        dataOrder: dataOrder.data.success.data,
        processingFetchTableData: false,
        loadingButton: false,
        tableSelectedRowKeys: [],
      });
    } catch (error: any) {
      this.setState({
        dataOrder: [],
        processingFetchTableData: false,
        loadingButton: false,
        tableSelectedRowKeys: [],
      });
      Modal.error({
        title: "Validation Error",
        content: error.message,
      });
    }
  };

  render() {
    const rowTableSelection = {
      onChange: (selectedRowKeys: any, selectedRows: any) => {
        this.setState({
          tableSelectedRowKeys: selectedRows,
        });
      },
    };

    return (
      <MainLayout onChangeDealer={this.onDealerChange} breadcrumbPath={`BBN`} breadcrumbMenu={`Payment Approval`} defaultSelectedKeys={["m-bbn-payment-approval"]} defaultOpenKeys={["sm-bbn"]}>
        <div className="page-order-list">
          <Form name="form-filter" layout="vertical">
            <Row>
              <Col style={{ paddingLeft: 2, paddingRight: 2, minWidth: 150 }}>
                {/* <SelectStatusBBN value={this.state.filterValueStatus} onChangeValue={this.changeFilterStatus} /> */}
                <Form.Item style={{ minWidth: 180 }} label="Biro Jasa">
                  <ServicebureauSelect onSupplierChangeProps={this.changeServiceBureau} dealerCode={this.state.filterValueDealer} value={this.state.service_code} />
                </Form.Item>
              </Col>
              <Col style={{ paddingLeft: 2, paddingRight: 2, minWidth: 150 }}>
                <Form.Item label="Tanggal Order">
                  <DatePicker onChange={this.changeFilterDate} picker="month" value={this.state.filterValueDate ? moment(this.state.filterValueDate) : undefined} />
                </Form.Item>
              </Col>
              <Col style={{ paddingLeft: 2, paddingRight: 2 }}>
                <Form.Item label="&nbsp;">
                  <Button
                    onClick={this.clickSearch}
                    type="primary"
                    icon={<SearchOutlined />}
                    title="filter"
                    style={{ minWidth: "50%", background: "#1784b8", borderColor: "#1784b8" }}
                    loading={this.state.loadingButton}
                  >
                    Filter
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <Table
            rowKey="order_code"
            size={"small"}
            columns={this.tableColumn}
            dataSource={this.state.dataOrder}
            pagination={false}
            scroll={{ x: 2000, y: 550 }}
            // scroll={{ x: "calc(500px + 50%)" }}
            rowSelection={rowTableSelection}
          />
        </div>
        <ModalPaymentApproval
          dataOrder={this.state.rowPaymentApproval}
          visible={this.state.showModalPaymentApproval}
          onClose={this.closeModalPaymentApproval}
          onApprovePayment={this.onApprovePayment}
          loading={this.state.loadingButton}
        />
      </MainLayout>
    );
  }
}

export default withAuth(withRouter(PaymentApproval), 64);
